// extracted by mini-css-extract-plugin
export default {"select":"select_select__20SzW","fullWidth":"select_fullWidth__k3Cd-","placeholder":"select_placeholder__gmsKh"};